import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

interface PropsType {
    className?: string;
    onClick?: () => void;
}

export const AdminIcon = observer(
    'AdminIcon',
    ({ className, onClick }: PropsType): JSX.Element => (
        <SvgElement
            className={className}
            onClick={onClick}
            fill='none'
            width='28'
            height='28'
            viewBox='0 0 28 28'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                stroke='#E4E4E7'
                strokeLinecap='round'
                strokeLinejoin='round'
                d='M23.333 8.167h-10.5m3.5 11.666h-10.5m10.5 0a3.5 3.5 0 1 0 7 0 3.5 3.5 0 0 0-7 0ZM11.667 8.167a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z'
            />
        </SvgElement>
    )
);
